import * as mobile from './mobile'
import * as web from './web'
import * as cx from './cx'
import * as cx2 from './cx2'
import * as customerHub from './customerHub'
import * as mobile2 from './mobile2'

export default {
  mobile,
  'mobile-v2': mobile2,
  'web-modular': web,
  'web-social': web,
  'customer-experience': cx,
  'customer-experience-v2': cx2,
  'customer-hub': customerHub,
}
